import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_HEADER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: HEIGHT_HEADER,
				zIndex: 1111
			},
			header: {
				display: "flex",
				padding: 19,
				justifyContent: "center",
				alignItems: "center"
			},
			btnBack: {
				marginRight: 10,
				cursor: "pointer",
				position: "absolute",
				left: 16,
				"& > svg": {
					fill: theme.palette.primary.contrastText
				},
				"&:active": {
					opacity: 0.7
				}
			},
			btnLogout: {
				marginRight: 10,
				cursor: "pointer",
				position: "absolute",
				fontSize: 14,
				right: 16,
				color: theme.palette.secondary.main,
				"&:active": {
					opacity: 0.7
				}
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 600
			}
		}),
	{
		name: "HeaderPage",
		index: 1
	}
);

export default useStyles;
